export const main_services_list = [
    { value: 'emergency', label: 'Emergency - Toothpain/Broken tooth' },
    { value: 'teeth_whitening', label:'Teeth Whitening' },
    { value: 'dental_checkup', label: 'Dental checkup' },
    { value: 'teeth_cleaning', label: 'Teeth cleaning' },
    { value: 'online_dentist', label: 'Online Dentist' },
  ];
